import type { Resource } from '../../';
export const product_details_estimatedShipping: Resource = {"default":"Estimated Shipping: {estimatedShippingRange}"};
